import React, {useEffect, useRef, useState} from 'react';
import {toast, ToastContainer} from "react-toastify";
import SideBar from "../../../../common/SideBar";
import NavBar from "../../../../common/NavBar";
import Spinner from "reactjs-simple-spinner";
import {Link} from "react-router-dom";
import PoliciesService from "../../../../services/PoliciesService";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import {Timeline} from 'primereact/timeline';
import {Card} from 'primereact/card';
import ReactToPrint from 'react-to-print';
import './Timeline.css';


const Alterations = (props) => {
    const componentRef = useRef();

    const [loading, setLoading] = useState(true);
    const [policyNumber, setPolicyNumber] = useState('')
    const [policies, setPolicies] = useState([])
    const [policyAlterations, setPolicyAlterations] = useState([])

    useEffect(() => {
        setLoading(true)
        setPolicyAlterations([])
        //    get allPolicies
        PoliciesService.getAllPolicies()
            .then(response => {
                console.log("res: ", response)
                setPolicies(response.data.policies)
                setLoading(false)
            }).catch(err => {
            console.error(err)
            setPolicies([])
            setLoading(false)
        })
    }, [])

    const defaultProps = {
        options: policies,
        getOptionLabel: (option) => option.policy_number,
    };

    const handleSearch = () => {
        setLoading(true);

        if (policyNumber === '' || policyNumber === undefined) {
            setLoading(false)
            toast.warning('Please provide a policy number');
            return
        }
        //    search for policy details by policyNumber
        PoliciesService.alterations({"policy_number": policyNumber})
            .then(response => {
                console.log("res: ", response)
                if (response.status === 200) {
                    setPolicyNumber('')
                    setPolicyAlterations(response.data.data)
                    setLoading(false)
                }
            }).catch(err => {
            console.log("error: ", err)
            setPolicyAlterations([])
            setLoading(false);
            toast.warning('Network Error, Try again \nIf error persists contact System Administrator ');
            console.log('err: ', err)
        })

    }

    const handleChangePolicyNumber = (e, v, name) => {
        if (v.policy_number === null || v.policy_number === undefined) {
            console.log(v.policy_number)
            setPolicyNumber('')
        } else {
            console.log(v.policy_number)
            setPolicyNumber(v.policy_number)
        }

    }



    const customizedContent = (item) => {

        return (
            <Card title={item.event} subTitle={item.created_at} className="p-2 m-3">

                <p className="col-md-12">
                    <h5 className="font-weight-bold">Initial Values</h5>
                    <pre style={{background: '#f5f5f5', padding: '2px'}}>
                         <code>{JSON.stringify(item.initial_values, null, 2)}</code>
                    </pre>
                    <hr/>
                    <h5 className="font-weight-bold">Updated Values</h5>
                    <pre style={{background: '#f5f5f5', padding: '2px'}}>
                         <code>{JSON.stringify(item.new_values, null, 2)}</code>
                    </pre>
                    <hr/>
                </p>
            </Card>
        );
    };

    return (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
                <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                {loading && (
                    <div className="container">
                        <form className="loader">
                            <div className="login-wrap p-5 mt-5">
                                <Spinner
                                    size="large"
                                    message="Please Wait..."
                                    line-fg-color="#64c3c2"
                                />
                            </div>
                        </form>
                    </div>
                )}
                {!loading && (
                    <div className="content">
                        <div className="container-fluid">
                            <ul className="breadcrumb">
                                <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                                &nbsp;|&nbsp;
                                <span
                                    className="text-capitalize">
                                    View Policy Alterations </span>
                            </ul>

                            {/*    content*/}
                            <div className="row mt">
                                <div className="card container col-lg-12">
                                    <div className="content-panel bg-white p-3">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <Autocomplete
                                                    {...defaultProps}
                                                    id="auto-complete"
                                                    autoComplete
                                                    onChange={(e, v) => handleChangePolicyNumber(e, v, props.name)}
                                                    includeInputInList
                                                    renderInput={(params) =>
                                                        <TextField {...params} label="Input PolicyNumber"
                                                                   margin="normal" fullWidth
                                                        />}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <button onClick={handleSearch} className="btn btn-sm btn-primary">
                                                    <i className="fa fa-search"/>&nbsp;
                                                    Search Policy Alterations
                                                </button>
                                            </div>
                                        </div>
                                        <hr/>
                                        <div className="row col-md-12">
                                            <ReactToPrint
                                                trigger={() => <button className="btn btn-sm btn-secondary">
                                                    <i className="fa fa-print"/>&nbsp;
                                                    Print
                                                </button>}
                                                content={() => componentRef.current}
                                            />
                                        </div>
                                        <div className="row col-md-6">
                                            <div ref={componentRef} className="container">
                                                <Timeline value={policyAlterations} align="left"
                                                              className="customized-timeline"
                                                              content={customizedContent}/>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                )}
            </div>

        </div>
    );
}

export default Alterations;
